import { Row, Col } from "antd";
import { CodeSandboxOutlined } from "@ant-design/icons";
import sideMenu from "../../../assets/images/side-menu.svg";
import POSLogo from "../../../assets/images/NewLogoCW.svg";
import LockIcon from "../../../assets/images/lock-icon.svg";
import userIcon from "../../../assets/images/userId.svg";
import Ofline from "../../../assets/images/red.svg";
import Online from "../../../assets/images/green.svg";
import useAuthStore from "../../../stores/useAuthStore";

const HeaderBar = ({
  colorVariable,
  themeJSON,
  posConfig,
  formattedDateTime,
  userData,
  isOnline,
  showSaleType,
  selectedSaleType,
  cart,
  setTillLink,
  setIsSaleTypeFlag,
  setIsLocked,
  setShowCustomMix,
  deleteReceipt,
  history,
  errorMessage,
}) => {
  return (
    <Row
      style={{
        padding: "0.4% 0.5%",
        height: "9vh",
        alignItems: "center",
        fontSize: "1vw",
        width: "100%",
      }}
    >
      <Col
        onClick={() => setTillLink(true)}
        style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
        span={1.2}
      >
        <img src={sideMenu} style={{ paddingLeft: "0.5rem", height: "2vw" }} />
      </Col>
      <Col
        span={4}
        onDoubleClick={() => {
          deleteReceipt(true);
          const isPreOrder = posConfig?.enablePreOrder === "Y";
          const isEstimate = posConfig?.enableEstimate === "Y";
          history.push(isPreOrder && isEstimate ? "/estimate" : "/pos");
        }}
        style={{ cursor: "pointer" }}
      >
        <img src={themeJSON.logoURL || POSLogo} style={{ height: "2.5vw", paddingLeft: "0.4vw" }} />
      </Col>
      <Col
        span={3}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {showSaleType === true ? (
          <span
            style={{ display: "flex", alignItems: "center", color: "#0F0718", fontFamily: "Inter", fontWeight: 500, fontSize: "13px", paddingLeft: "1vw", cursor: "pointer" }}
            onClick={() => { if (cart.docType !== "Advance") setIsSaleTypeFlag(true); }}
          >
            {selectedSaleType}
          </span>
        ) : ""}
      </Col>
      <Col span={2} />
      <Col
        span={4}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <span
          style={{
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: "1em",
            color: themeJSON.dateTimeTextColor || "#929098",
          }}
        >
          {" "}
          {formattedDateTime}
        </span>
      </Col>
      <Col
        span={2}
        style={{
          textAlign: "center",
          color: themeJSON.orderNoTextColor || "#0F0718",
          fontFamily: "Inter",
          fontWeight: 500,
          fontSize: "1.1em",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {posConfig?.enableProductGrouping === "Y" && (
          <CodeSandboxOutlined
            style={{ fontSize: "18px", cursor: "pointer" }}
            onClick={() => { setShowCustomMix(true); localStorage.setItem("customMix", "CM"); }}
          />
        )}
      </Col>
      <Col
        span={4}
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          paddingleft: "2vw",
        }}
      />
      <Col
        span={4}
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        }}
      >
        <img
          onClick={() => {
            if (isOnline) { setIsLocked(true); }
            else { errorMessage("Sync Failed", "Please check your network connection and try again"); }
          }}
          src={LockIcon}
          style={{ height: "3vh", cursor: "pointer", marginRight: "0.7rem" }}
        />
        <div style={{ display: "flex", alignItems: "end", justifyContent: "center", padding: "0.5vw", border: "1px solid #3C424B", borderRadius: "50%" }}>
          <img src={userIcon} style={{ height: "2.7vh" }} />
        </div>
        <div style={{ marginLeft: "1vw", display: "flex", flexDirection: "column" }}>
          <span style={{ color: themeJSON.orderNoTextColor || "#0F0718", fontSize: "1em", fontFamily: "Inter", fontWeight: "500", wordWrap: "break-word" }}>
            {userData?.user}
          </span>
          <span style={{ color: themeJSON.orderNoTextColor || "#0F0718", fontSize: "0.8em", fontFamily: "Inter", fontWeight: "500", wordWrap: "break-word" }}>
            Till ID : {useAuthStore.getState().tillValue?.name}
          </span>
        </div>
        <div style={{ marginLeft: "3%" }}>
          <img src={Online} style={{ display: !isOnline && "none", height: "2.5vh", cursor: "pointer", paddingBottom: "0.5vh" }} />{" "}
          <img src={Ofline} style={{ display: isOnline && "none", height: "2.5vh", cursor: "pointer", paddingBottom: "0.5vh" }} />{" "}
        </div>
      </Col>
    </Row>
  );
};

export default HeaderBar;
